import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bb6ed374")

_pushScopeId("data-v-bb6ed374")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo",
    src: "/assets/img/logo.png"
  })
], -1)
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "logo-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, {
        class: "bgimage",
        fullscreen: true
      }, {
        default: _withId(() => [
          _createVNode(_component_ion_grid, { class: "main-grid" }, {
            default: _withId(() => [
              _createVNode(_component_ion_row, { class: "main-row" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { size: "2" }),
                  _createVNode(_component_ion_col, null, {
                    default: _withId(() => [
                      _hoisted_1,
                      _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('Manage My Wedding')), 1),
                      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.message || _ctx.$t("We're taking some time to work on our relationship, please check back later.")), 1),
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          shape: "round",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRetryAccess()))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Try Again')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "2" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})